<template>
  <div class="home bg-slate-100">
    <HeroSection />
    <!-- <HelloWorld msg="Pet shop"/> -->
    <PuppyList />
    <!-- <jsonData /> -->

  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import HeroSection from '@/components/HeroSection.vue'
import PuppyList from '@/components/PuppyList.vue'
// import jsonData from '@/components/jsonData.vue'



export default {
  name: 'HomeView',
  components: {
    // HelloWorld,
    HeroSection,
    PuppyList,
    // jsonData
  },
}
</script>
